import React from 'react';
import './Banner.css'
const Banner = () => {
    return (
        <div>
            <div className="banner-container">

                <div className="banner-details">
                    <h1>Welcome to
                        <br /> Online Courses</h1>
                    <br />
                    <button>Apply Now &#8594;</button>

                </div>
            </div>

        </div>
    );
};

export default Banner;